import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-grafana-support-dashboards',
  templateUrl: './grafana-support-dashboards.component.html',
  styleUrls: ['./grafana-support-dashboards.component.css']
})
export class GrafanaSupportDashboardsComponent {
  @Input() src: string = '';
  @Input() token: string = '';
  @Input() height: string = '2000px';
  @Input() width: string = '100%';

  doorStatusUrl: string = `https://main.friggkantine.no/service/grafana/d/adkbblx/door-status?orgId=1&timezone=browser&var-source=mqtt_1&refresh=1m&theme=light&from=now-24h&to=now&theme=light&kiosk=1`;
  simStatusUrl: string = `https://main.friggkantine.no/service/grafana/d/ad2bcks/sim-overview?orgId=1&from=now-24h&to=now&refresh=1m&timezone=browser&theme=light&kiosk=1`;
}
